import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@coval/ui"
import { ChevronDown, CircleAlert } from "lucide-react"

import { reportCoverageNotes } from "../../utils/reportCoverageNotes"
import { reportClass } from "./ReportStyles"

/** Saved coverage notes the viewer keeps visible on every read. */
export function CoverageNotice({
  coverage,
}: {
  coverage: Record<string, unknown> | undefined
}) {
  if (!coverage) {
    return null
  }
  const notes = reportCoverageNotes(coverage)
  if (!notes.length) {
    return null
  }
  return (
    <div className={reportClass("coverage-notice")}>
      <CircleAlert size={15} />
      <div>
        <strong>Read this with its coverage in mind</strong>
        <p>{notes[0]}</p>
        {notes.length > 1 && (
          <Collapsible>
            <CollapsibleTrigger asChild>
              <Button variant="ghost" className="group">
                <ChevronDown
                  aria-hidden="true"
                  className="transition-transform group-data-[state=open]:rotate-180"
                />
                {notes.length - 1} more data{" "}
                {notes.length === 2 ? "note" : "notes"}
              </Button>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <ul>
                {notes.slice(1).map((note) => (
                  <li key={note}>{note}</li>
                ))}
              </ul>
            </CollapsibleContent>
          </Collapsible>
        )}
      </div>
    </div>
  )
}
